"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BillingRules = class BillingRules extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getContainer(...args) {
        return {
            self: this.$fn.urlFor('create_object_by_type'),
            object: 'list',
            data: []
        };
    }
    getPayload(...args) {
        const [editor] = args;
        const exclude = [];
        return editor.isNew ?
            editor.getData({ exclude }) :
            editor.getChanges({ exclude, skipEmbeddedLists: true });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    items;
    async $$load_items() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'billing-rule' }, asResource: true });
    }
    selectedItem;
    async $$load_selectedItem() {
        return this.items.length ? this.items[0] : null;
    }
    createItem;
    editingItemID;
    ux;
    b_7315092382398562_modalBindings;
    b_1040167445267876_style;
    b_1747314907724257_style;
    b_8363486085232621_style;
    b_4186377094414664_style;
    dataMembers = ['formId', 'formName', 'items', 'selectedItem', 'createItem', 'editingItemID', 'ux', 'b_7315092382398562_modalBindings', 'b_1040167445267876_style', 'b_1747314907724257_style', 'b_8363486085232621_style', 'b_4186377094414664_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "billingListItem",
                items: null,
                selectedItem: null,
                createItem: false,
                editingItemID: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_1040167445267876_style: {
                    minHeight: "300px",
                },
                b_1747314907724257_style: {
                    minWidth: "20px",
                },
                b_8363486085232621_style: {
                    minWidth: "20px",
                },
                b_4186377094414664_style: {
                    minHeight: "300px",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("BillingRules|Title", "Billing Rules"),
                    '(' + (this.items ? this.items.length : 0) + ')',
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2334_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_6466705138206980_clickPreventStop(event, scope) {
        return await this.actions.evh_6466705138206980_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_2340_getActionArgs($event) {
        return {
            name: "FileSelector",
            props: {
                url: this.$fn.urlFor('import_object_by_type', { object_type: 'billing-rule' }),
                accept: ".json",
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_5731695935601903_script_2344_getActionArgs_value($event) {
        (this.setData('createItem', null), this.setData('editingItemID', null));
    }
    async act_5731695935601903_script_2344_getActionArgs($event) {
        return {
            value: () => this.act_5731695935601903_script_2344_getActionArgs_value($event),
        };
    }
    async evh_5731695935601903_saved(event, scope) {
        return await this.actions.evh_5731695935601903_saved.executeFromDOM(this, event, scope);
    }
    async act_5731695935601903_script_2348_getActionArgs_value($event) {
        (this.setData('createItem', null), this.setData('editingItemID', null));
    }
    async act_5731695935601903_script_2348_getActionArgs($event) {
        return {
            value: () => this.act_5731695935601903_script_2348_getActionArgs_value($event),
        };
    }
    async evh_5731695935601903_cancelEdit(event, scope) {
        return await this.actions.evh_5731695935601903_cancelEdit.executeFromDOM(this, event, scope);
    }
    async act_4196617261796474_script_2350_getActionArgs_value($event) {
        this.editingItemID = $event.scope.item.id;
    }
    async act_4196617261796474_script_2350_getActionArgs($event) {
        return {
            value: () => this.act_4196617261796474_script_2350_getActionArgs_value($event),
        };
    }
    async evh_4196617261796474_clickPreventStop(event, scope) {
        return await this.actions.evh_4196617261796474_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_261555069697365_rest_2352_getActionArgs($event) {
        return {
            method: "delete",
            resource: $event.scope.item,
        };
    }
    async evh_261555069697365_clickPreventStop(event, scope) {
        return await this.actions.evh_261555069697365_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2272469684735879_script_2356_getActionArgs_value($event) {
        (this.setData('createItem', null), this.setData('editingItemID', null));
    }
    async act_2272469684735879_script_2356_getActionArgs($event) {
        return {
            value: () => this.act_2272469684735879_script_2356_getActionArgs_value($event),
        };
    }
    async evh_2272469684735879_saved(event, scope) {
        return await this.actions.evh_2272469684735879_saved.executeFromDOM(this, event, scope);
    }
    async act_2272469684735879_script_2360_getActionArgs_value($event) {
        (this.setData('createItem', null), this.setData('editingItemID', null));
    }
    async act_2272469684735879_script_2360_getActionArgs($event) {
        return {
            value: () => this.act_2272469684735879_script_2360_getActionArgs_value($event),
        };
    }
    async evh_2272469684735879_cancelEdit(event, scope) {
        return await this.actions.evh_2272469684735879_cancelEdit.executeFromDOM(this, event, scope);
    }
    async act_3373384577795494_script_2362_getActionArgs_value($event) {
        this.createItem = true;
    }
    async act_3373384577795494_script_2362_getActionArgs($event) {
        return {
            value: () => this.act_3373384577795494_script_2362_getActionArgs_value($event),
        };
    }
    async evh_3373384577795494_clickPreventStop(event, scope) {
        return await this.actions.evh_3373384577795494_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3601807637515735_script_2364_getActionArgs_value($event) {
        this.createItem = true;
    }
    async act_3601807637515735_script_2364_getActionArgs($event) {
        return {
            value: () => this.act_3601807637515735_script_2364_getActionArgs_value($event),
        };
    }
    async evh_3601807637515735_clickPreventStop(event, scope) {
        return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_2140198529698299_clickPreventStop(event, scope) {
        return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2334 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2334_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2333 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2334,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2333],
        });
        const act_2248226175642056_closeModal_2336 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_2335 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_2336,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2335],
        });
        const act_6466705138206980_reloadComponentData_2338 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_6466705138206980_clickPreventStop_2337 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_reloadComponentData_2338,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_6466705138206980_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_clickPreventStop_2337],
        });
        const act_8320016629450276_reloadComponentData_2342 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8320016629450276_close_2341 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_2342,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_8320016629450276_showModal_2340 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_2340_getActionArgs,
            events: [evh_8320016629450276_close_2341],
        });
        const evh_8320016629450276_clickPreventStop_2339 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_2340,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_2339],
        });
        const act_5731695935601903_script_2344 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5731695935601903_script_2344_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_saved_2343 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_script_2344,
            event: "saved",
            displayName: "script",
        });
        const act_5731695935601903_reloadComponentData_2346 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5731695935601903_saved_2345 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_reloadComponentData_2346,
            event: "saved",
            displayName: "reloadComponentData",
        });
        const evh_5731695935601903_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5731695935601903_saved_2343, evh_5731695935601903_saved_2345],
        });
        const act_5731695935601903_script_2348 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5731695935601903_script_2348_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_cancelEdit_2347 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_script_2348,
            event: "cancelEdit",
            displayName: "script",
        });
        const evh_5731695935601903_cancelEdit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5731695935601903_cancelEdit_2347],
        });
        const act_4196617261796474_script_2350 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4196617261796474_script_2350_getActionArgs,
            displayName: "editItem",
            events: [],
        });
        const evh_4196617261796474_clickPreventStop_2349 = new core_1.actions.EventHandlerImpl({
            action: act_4196617261796474_script_2350,
            event: "click.prevent.stop",
            displayName: "editItem",
        });
        const evh_4196617261796474_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4196617261796474_clickPreventStop_2349],
        });
        const act_261555069697365_reloadComponentData_2354 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_261555069697365_deleted_2353 = new core_1.actions.EventHandlerImpl({
            action: act_261555069697365_reloadComponentData_2354,
            event: "deleted",
            displayName: "reloadComponentData",
        });
        const act_261555069697365_rest_2352 = new core_1.actions.RestAction({
            actionArgs: this.act_261555069697365_rest_2352_getActionArgs,
            displayName: "deleteItem",
            events: [evh_261555069697365_deleted_2353],
        });
        const evh_261555069697365_clickPreventStop_2351 = new core_1.actions.EventHandlerImpl({
            action: act_261555069697365_rest_2352,
            event: "click.prevent.stop",
            displayName: "deleteItem",
        });
        const evh_261555069697365_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_261555069697365_clickPreventStop_2351],
        });
        const act_2272469684735879_script_2356 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2272469684735879_script_2356_getActionArgs,
            events: [],
        });
        const evh_2272469684735879_saved_2355 = new core_1.actions.EventHandlerImpl({
            action: act_2272469684735879_script_2356,
            event: "saved",
            displayName: "script",
        });
        const act_2272469684735879_reloadComponentData_2358 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2272469684735879_saved_2357 = new core_1.actions.EventHandlerImpl({
            action: act_2272469684735879_reloadComponentData_2358,
            event: "saved",
            displayName: "reloadComponentData",
        });
        const evh_2272469684735879_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2272469684735879_saved_2355, evh_2272469684735879_saved_2357],
        });
        const act_2272469684735879_script_2360 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2272469684735879_script_2360_getActionArgs,
            events: [],
        });
        const evh_2272469684735879_cancelEdit_2359 = new core_1.actions.EventHandlerImpl({
            action: act_2272469684735879_script_2360,
            event: "cancelEdit",
            displayName: "script",
        });
        const evh_2272469684735879_cancelEdit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2272469684735879_cancelEdit_2359],
        });
        const act_3373384577795494_script_2362 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3373384577795494_script_2362_getActionArgs,
            displayName: "createRule",
            events: [],
        });
        const evh_3373384577795494_clickPreventStop_2361 = new core_1.actions.EventHandlerImpl({
            action: act_3373384577795494_script_2362,
            event: "click.prevent.stop",
            displayName: "createRule",
        });
        const evh_3373384577795494_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3373384577795494_clickPreventStop_2361],
        });
        const act_3601807637515735_script_2364 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3601807637515735_script_2364_getActionArgs,
            displayName: "createRule",
            events: [],
        });
        const evh_3601807637515735_clickPreventStop_2363 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_script_2364,
            event: "click.prevent.stop",
            displayName: "createRule",
        });
        const evh_3601807637515735_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3601807637515735_clickPreventStop_2363],
        });
        const act_2140198529698299_closeComponent_2366 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2140198529698299_clickPreventStop_2365 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_closeComponent_2366,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_2140198529698299_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_clickPreventStop_2365],
        });
        return {
            act_7315092382398562_closeModal_2334,
            evh_7315092382398562_close_2333,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_2336,
            evh_2248226175642056_close_2335,
            evh_2248226175642056_close,
            act_6466705138206980_reloadComponentData_2338,
            evh_6466705138206980_clickPreventStop_2337,
            evh_6466705138206980_clickPreventStop,
            act_8320016629450276_reloadComponentData_2342,
            evh_8320016629450276_close_2341,
            act_8320016629450276_showModal_2340,
            evh_8320016629450276_clickPreventStop_2339,
            evh_8320016629450276_clickPreventStop,
            act_5731695935601903_script_2344,
            evh_5731695935601903_saved_2343,
            act_5731695935601903_reloadComponentData_2346,
            evh_5731695935601903_saved_2345,
            evh_5731695935601903_saved,
            act_5731695935601903_script_2348,
            evh_5731695935601903_cancelEdit_2347,
            evh_5731695935601903_cancelEdit,
            act_4196617261796474_script_2350,
            evh_4196617261796474_clickPreventStop_2349,
            evh_4196617261796474_clickPreventStop,
            act_261555069697365_reloadComponentData_2354,
            evh_261555069697365_deleted_2353,
            act_261555069697365_rest_2352,
            evh_261555069697365_clickPreventStop_2351,
            evh_261555069697365_clickPreventStop,
            act_2272469684735879_script_2356,
            evh_2272469684735879_saved_2355,
            act_2272469684735879_reloadComponentData_2358,
            evh_2272469684735879_saved_2357,
            evh_2272469684735879_saved,
            act_2272469684735879_script_2360,
            evh_2272469684735879_cancelEdit_2359,
            evh_2272469684735879_cancelEdit,
            act_3373384577795494_script_2362,
            evh_3373384577795494_clickPreventStop_2361,
            evh_3373384577795494_clickPreventStop,
            act_3601807637515735_script_2364,
            evh_3601807637515735_clickPreventStop_2363,
            evh_3601807637515735_clickPreventStop,
            act_2140198529698299_closeComponent_2366,
            evh_2140198529698299_clickPreventStop_2365,
            evh_2140198529698299_clickPreventStop,
            reload: act_6466705138206980_reloadComponentData_2338,
            editItem: act_4196617261796474_script_2350,
            deleteItem: act_261555069697365_rest_2352,
            createRule: act_3601807637515735_script_2364,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BillingRules.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingRules.prototype, "onSize", null);
BillingRules = __decorate([
    (0, vue_property_decorator_1.Component)()
], BillingRules);
exports.default = BillingRules;
vue_property_decorator_1.Vue.component("BillingRules", BillingRules);
